import { Target, AlertTriangle, BarChart3, MessageSquare } from 'lucide-react'
import type { StakeholderTemplate } from '@bandos/shared'
import { PortraitDisplay } from './PortraitDisplay'
import {
  ProfileContent,
  ProfileName,
  ProfileRole,
  ProfileRoleSummary,
  ProfileSection,
  ProfileSectionTitle,
  ProfileSectionList,
  ProfileSectionItem,
} from '../styles/CharacterSelectionModalStyles'

interface ProfileViewProps {
  template: StakeholderTemplate
  isGenerating: boolean
  brokenPortraits: Set<string>
  markPortraitBroken: (id: string) => void
}

export function ProfileView({
  template,
  isGenerating,
  brokenPortraits,
  markPortraitBroken,
}: ProfileViewProps) {
  return (
    <ProfileContent>
      <PortraitDisplay
        template={template}
        size="large"
        brokenPortraits={brokenPortraits}
        markPortraitBroken={markPortraitBroken}
        isGenerating={isGenerating}
      />

      <ProfileName>{template.name}</ProfileName>
      {template.role && <ProfileRole>{template.role}</ProfileRole>}
      {template.role_summary && <ProfileRoleSummary>{template.role_summary}</ProfileRoleSummary>}

      {template.goals && template.goals.length > 0 && (
        <ProfileSection>
          <ProfileSectionTitle>
            <Target size={12} />
            Goals
          </ProfileSectionTitle>
          <ProfileSectionList>
            {template.goals.map((goal, i) => (
              <ProfileSectionItem key={i}>{goal}</ProfileSectionItem>
            ))}
          </ProfileSectionList>
        </ProfileSection>
      )}

      {template.concerns && template.concerns.length > 0 && (
        <ProfileSection>
          <ProfileSectionTitle>
            <AlertTriangle size={12} />
            Concerns
          </ProfileSectionTitle>
          <ProfileSectionList>
            {template.concerns.map((concern, i) => (
              <ProfileSectionItem key={i}>{concern}</ProfileSectionItem>
            ))}
          </ProfileSectionList>
        </ProfileSection>
      )}

      {template.success_metrics && template.success_metrics.length > 0 && (
        <ProfileSection>
          <ProfileSectionTitle>
            <BarChart3 size={12} />
            Success Metrics
          </ProfileSectionTitle>
          <ProfileSectionList>
            {template.success_metrics.map((metric, i) => (
              <ProfileSectionItem key={i}>{metric}</ProfileSectionItem>
            ))}
          </ProfileSectionList>
        </ProfileSection>
      )}

      {template.feedback_style?.extra_rules && template.feedback_style.extra_rules.length > 0 && (
        <ProfileSection>
          <ProfileSectionTitle>
            <MessageSquare size={12} />
            Feedback Rules
          </ProfileSectionTitle>
          <ProfileSectionList>
            {template.feedback_style.extra_rules.map((rule, i) => (
              <ProfileSectionItem key={i}>{rule}</ProfileSectionItem>
            ))}
          </ProfileSectionList>
        </ProfileSection>
      )}
    </ProfileContent>
  )
}
